module.exports = __webpack_public_path__ + "img/head.ef8b44fa.png";